<ui-input-select-wrapper [open]="open()" (openChange)="open.set($event)" noOverlay>
    <ui-input-wrapper
        [label]="label()"
        [value]="selected()?.join(', ') ?? placeholder() ?? undefined"
        [disabled]="disabled()"
        [focussed]="selectedLength() > 0"
        (clicked)="!disabled() ? openDropdown() : null"
    >
        <i
            class="icon-chevron-down ml-auto text-accent transition-transform"
            [ngClass]="{ 'rotate-180': open() }"
            trailing
        ></i>
    </ui-input-wrapper>

    <div class="flex w-full flex-col gap-16 px-16 py-12 pt-12" dropdown>
        @for (option of options(); let i = $index; track i) {
            <ui-input-checkbox
                [checked]="selected()?.includes(option.value) ?? false"
                (checkedChange)="addOrRemoveKey(option.value, $event)"
            >
                <span class="contents" [innerHTML]="option.label"></span>
            </ui-input-checkbox>
        }
    </div>
</ui-input-select-wrapper>
